import React from 'react';
import { FormatComponentProps } from './types';

const Heading: React.FC<FormatComponentProps> = ({ content }) => {
  const headingText = content.replace(/^###\s*/, '');
  return <strong>{headingText}</strong>;
};

export default Heading;
